<template>
  <a-range-picker
    :allowClear="allowClear"
    :open="open"
    format="YYYY-MM"
    v-bind="$attrs"
    :mode="mode2"
    :defaultPickerValue="defaultPickerValue"
    v-model="dateValue"
    @change="clearValue"
    @openChange="handleOpenChange"
    @panelChange="handlePanelChange">
      <template slot="renderExtraFooter" style="width: 100%;">
        <div class="pickerButtonDiv" :style="dataButtonShow ? 'justify-content: space-between;':'justify-content: flex-end;'">
          <div class="dateButtonDiv" v-if="dataButtonShow">
            <template v-for="(year,index) in $t('baseVO.monthRangePicker.yearList')">
              <div class="ant-tag ant-tag-blue" @click="dateChange(year.year)">{{year.name}}</div>
            </template>
          </div>
          <a-button  @click="closePicker" key="submit" type="primary">{{$t('baseVO.confirm')}}</a-button>
        </div>
      </template>
      <span slot="suffixIcon">
        <slot name="suffixIcon"></slot>
      </span>
  </a-range-picker>


</template>

<script>
  import moment from 'moment'
  export default {
    name: 'ptMonthRange',
    props:{
      allowClear:{
        default: true,
      },
      value:{
        default:undefined,
      },
      dataButtonShow:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        mode1: 'time',
        mode2: ['month', 'month'],
        dateValue:this.value?this.value:[],
        dateValueStr:[],
        defaultPickerValue:[moment().month(0),moment().month(11).year(moment().year()+1)],
        open:false,
      }
    },
    mounted(){
    },
    watch:{
      value(newValue){
        this.dateValue = newValue
      }
    },
    methods:{
      dateChange(year){
        console.log("时间改变之前");
        console.log(this.dateValue)
        var month = parseInt(year*12)-1;
        //如果当前时间为null则按今年一月份加时间
        var startDate = null;
        var endDate = null;
        var value = [];
        if(this.dateValue == null || this.dateValue.length == 0){
          startDate = moment(moment().year()+"-01-01");
          endDate = moment(startDate).add(month, 'months');
          value.push(startDate);
          value.push(endDate);
        }else{
          startDate = this.dateValue[0];
          endDate = moment(startDate).add(month, 'months');
          value.push(startDate);
          value.push(endDate);
        }
     //   this.$emit('input',value);
        this.dateValue = value;
        this.$emit('change',this.dateValue)
        this.$emit('input',this.dateValue)
        this.open = false;
      },
      handlePanelChange (value,mode){
        this.$emit('input',value)
        this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
        this.dateValue = value
        // this.$emit('change',value)
        this.$nextTick(()=>{
          this.$emit('change',this.dateValue)
        })
      },
      handleOpenChange (status) {
        console.log(status)
        if(status){
          this.open = true
        } else {
          this.open = false
        }
      },
      closePicker(){
        this.$nextTick(()=>{
          this.$emit('change',this.dateValue)
        })
        this.$emit('input',this.dateValue)
        this.open = false;
      },
      clearValue (value) {
        console.log("时间改变")
        this.dateValue = value
        this.$nextTick(()=>{
          this.$emit('change',value)
        })
        this.$emit('input',value)
      },
    }
  }
</script>

<style scoped lang="less">
  .pickerButtonDiv{
    .dateButtonDiv{
      display: flex;flex-direction: row;
      .buttonStyle{
        margin-right: 10px;
      }
    }
    width: 520px;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
  }
  .ant-calendar-footer-extra{
    width: 100%;
  }
</style>